import React, { FC } from 'react'
import { UngatedAssetDownloadContainer } from './style'

//* utils
import { WrapperImage as WrapperImageModel } from '../../../../models/others/image'
import { TopicCTA } from '../../../../models/topics/cta'
import ImgUtil from '../../../../utils/img.utils'
import { internalLinkHandler } from '../../../../utils/link.utils'

//* component
import Button from '../../../global/button'
import Typography from '../../../global/typography'
import WrapperImage from '../../../global/wrapperImage'

type Props = {
  data: {
    title: string
    text: string
    tileMedia: WrapperImageModel
    tileCta: TopicCTA
  } | null
}

const GatedAssetDownload: FC<Props> = ({ data }) => {
  if (!data) return null

  const gatedAssetData = {
    title: data.title || '',
    body: data.text || '',
    icon: {
      url: data.tileMedia?.image?.file?.url || '',
      alt: data.tileMedia?.altText || '',
    },
    cta: {
      text: data.tileCta?.text || '',
      link: data.tileCta?.internalLink
        ? internalLinkHandler(data.tileCta.internalLink)
        : data.tileCta?.externalUrl,
    },
  }

  return (
    <UngatedAssetDownloadContainer data-cy="UngatedAssetDownload">
      <WrapperImage
        src={ImgUtil.getResizedImageUrl(gatedAssetData.icon.url, '')}
        alt={gatedAssetData.icon.alt}
        width={64}
        height={64}
        threshold={650}
      />

      <p className="GatedAsset__Title">{gatedAssetData.title}</p>

      <Typography className="GatedAsset__Body" type="leadXS">
        {gatedAssetData.body}
      </Typography>

      {gatedAssetData.cta.link && (
        <Button
          icon={true}
          href={gatedAssetData.cta.link}
          className="GatedAsset__CTA"
          text={gatedAssetData.cta.text}
          type="primary"
          size="small"
          theme="light"
        />
      )}
    </UngatedAssetDownloadContainer>
  )
}

export default GatedAssetDownload
